import "./ProjectPhaseKPI.css";

import { useMemo } from "react";

import { getProjectPhaseLabel, parseProjectPhase, ProjectPhase } from "../../../../constants/project-phase";
import { logError } from "../../../../service/error";
import { GenericTooltip } from "../../../forms";

interface ProjectPhaseKPIProps {
  status: string;
  phase: string | null;
}

const getClassName = (status: string, projectPhase: string | null): string | null => {
  switch (parseProjectPhase(projectPhase)) {
    case ProjectPhase.feasibility:
      return "GraphBar1Filled";
    case ProjectPhase.design:
      return "GraphBar2Filled";
    case ProjectPhase.implementation:
      return "GraphBar3Filled";
    case ProjectPhase.ongoingMonitoring:
      return "GraphBar4Filled";
    default:
      if (status !== "Cancelled" && status !== "Not Delivered") {
        logError({
          error: `No ProjectPhaseKPI graph bar has been found for this project phase: ${projectPhase}`,
        });
      }
      return null;
  }
};

export const ProjectPhaseKPI = ({ status, phase }: ProjectPhaseKPIProps): JSX.Element => {
  const steps = useMemo(
    () => [
      {
        tooltipText: "Feasibility",
        flexSize: 1,
      },
      {
        tooltipText: "Design",
        flexSize: 1,
      },
      {
        tooltipText: "Implementation",
        flexSize: 1,
      },
      {
        tooltipText: "Ongoing Monitoring",
        flexSize: 1,
      },
    ],
    []
  );
  return (
    <div className="ProjectPhaseContainer">
      <div className={`ProjectPhaseGraph ${getClassName(status, phase)}`}>
        {steps.map((step) => {
          return (
            <GenericTooltip
              key={step.tooltipText}
              placement="bottomLeft"
              content={
                <div className="ProjectPhaseTooltipContainer">
                  <p className="body3">{step.tooltipText}</p>
                </div>
              }
            >
              <div className="GraphBarEmpty" style={{ flex: step.flexSize }} />
            </GenericTooltip>
          );
        })}
      </div>
      <div className="ProjectPhaseHeaderArea">
        <h2>{getProjectPhaseLabel(phase)}</h2>
        <p className="body2">Project phase</p>
      </div>
    </div>
  );
};
